import { render, staticRenderFns } from "./ClientAddressesHistory.vue?vue&type=template&id=674e1065&scoped=true&"
import script from "./ClientAddressesHistory.vue?vue&type=script&lang=js&"
export * from "./ClientAddressesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674e1065",
  null
  
)

export default component.exports